import { useEffect, useRef, useCallback } from 'react';

// https://css-tricks.com/using-requestanimationframe-with-react-hooks/
export const useAnimationFrame = (callback: () => void) => {
	const requestRef = useRef<number>();
	const previousTimeRef = useRef<number>();

	const animate = useCallback(
		(time: number) => {
			if (previousTimeRef.current !== undefined) {
				callback();
			}
			previousTimeRef.current = time;
			requestRef.current = requestAnimationFrame(animate);
		},
		[callback]
	);

	useEffect(() => {
		requestRef.current = requestAnimationFrame(animate);
		return () => cancelAnimationFrame(requestRef.current!);
	}, [animate]);
};
